module.exports = __webpack_public_path__ + "static/img/1.bfdea6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/eng/1.png
// module id = iVIO
// module chunks = 0